__turbopack_context__.v({
  "container": "HowItWorksSection-module__25z6yG__container",
  "howItWorksContent": "HowItWorksSection-module__25z6yG__howItWorksContent",
  "howItWorksHeading": "HowItWorksSection-module__25z6yG__howItWorksHeading",
  "howItWorksImageContainer": "HowItWorksSection-module__25z6yG__howItWorksImageContainer",
  "howItWorksSection": "HowItWorksSection-module__25z6yG__howItWorksSection",
  "howItWorksStep": "HowItWorksSection-module__25z6yG__howItWorksStep",
  "howItWorksSteps": "HowItWorksSection-module__25z6yG__howItWorksSteps",
  "howItWorksVideoContainer": "HowItWorksSection-module__25z6yG__howItWorksVideoContainer",
  "referrerBackgroundImage": "HowItWorksSection-module__25z6yG__referrerBackgroundImage",
  "referrerContainer": "HowItWorksSection-module__25z6yG__referrerContainer",
  "referrerImage": "HowItWorksSection-module__25z6yG__referrerImage",
  "referrerTextContainer": "HowItWorksSection-module__25z6yG__referrerTextContainer",
});
